import React, { useState, useEffect, forwardRef, useCallback, useRef } from "react";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import classNames from "classnames";
import { checkAdBlockerActive } from "../../services/AdBlockerService";
import wait from "../../utilities/wait";
import styled from "styled-components";

interface IAdobeTargetProps extends IStyledProps, IEditableProps {
    id: string;
    className: string;
    adobeWait: string;
    minHeight?: number;
    children?;
}

const AdobeTargetContainer = styled.div<{ $minHeight: number }>`
    min-height: ${(props) => props.$minHeight }px;
`;

const AdobeTarget = (props: IAdobeTargetProps) => {
    const { minHeight = 0, id, className, children } = props;
    const isBuildr = props.editorClassObj && props.editorClassObj.includes("CMS_WIDGET");
    const containerRef = useRef();
    const adobeWait = isBuildr ? 0 : Number(props.adobeWait || 0);
    const [{showTarget , loading}, setStatus] = useState({showTarget: false, loading: adobeWait > 0});
    const showFallback = !loading && !showTarget;

    function checkTargetEmpty(containerRef) {
        return containerRef.current.childNodes.length === 0;
    }

    useEffect(() => {
        async function startTarget() {
            if (adobeWait === 0 || isNaN(adobeWait)) {
                setStatus({showTarget: false, loading: false});
                return;
            }
            const adBlockerActive = await checkAdBlockerActive();
            if (adBlockerActive) {
                // Adobe blocked, hide target and show fallback
                setStatus({showTarget: false, loading: false});
            } else {
                // Show Adobe Target only if not empty
                await wait(adobeWait);
                setStatus({showTarget: !checkTargetEmpty(containerRef), loading: false});
            }
        }
        startTarget();
    }, []);

    return (<>
        {(loading || showTarget) ? <AdobeTargetContainer $minHeight={minHeight} ref={containerRef} id={id} className={classNames('adobe-target-content', className)}></AdobeTargetContainer> : null}
        {showFallback ? <AdobeTargetContainer $minHeight={minHeight} className={classNames(className)}>{children}</AdobeTargetContainer> : null}
    </>);
};

export default AdobeTarget;